import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockFooter.module.css';

const BlockFooter = props => {
  const { blockId, className, rootClassName, textClassName, blockName, title, text, options } = props;
  const classes = classNames(rootClassName || css.root, className);
  // blockName is a plain string from CMS; title is a field object (fallback)
  const hasTitleField = !blockName && hasDataInFields([title], options);
  const hasTextComponentFields = hasDataInFields([text], options);

  return (
    <BlockContainer id={blockId} className={classes}>
      {blockName ? (
        <div className={css.title}>{blockName}</div>
      ) : hasTitleField ? (
        <div className={css.title}>
          <Field data={title} options={options} />
        </div>
      ) : null}
      {hasTextComponentFields ? (
        <div className={classNames(textClassName, css.text)}>
          <Field data={text} options={options} />
        </div>
      ) : null}
    </BlockContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockFooter.defaultProps = {
  className: null,
  rootClassName: null,
  textClassName: null,
  blockName: null,
  title: null,
  text: null,
  options: null,
};

BlockFooter.propTypes = {
  blockId: string.isRequired,
  className: string,
  rootClassName: string,
  textClassName: string,
  blockName: string,
  title: object,
  text: object,
  options: propTypeOption,
};

export default BlockFooter;
